import http from "./http";

function getGeofencingList(data) {
  return http.post(`getGeoFenc`, data);
}
function addgeofencingdata(data) {
  return http.post(`Geo_Fenc`, data);
}
function UpdateGeofencing(data) {
  return http.post(`updateGeo_Fenc`, data);
}
function deleteGeofencingData(data) {
  return http.post(`delete_GeoFenc`, data);
}

function fencingAllotTovehicle(data) {
  return http.post(`Geofenc_set_tovehicle`, data);
}

function fetch_district_list(data) {
  return http.post(`allDistrictList`, data);
}

function fetch_vehicle_list(data) {
  return http.post(`District_wiseVehicleList_new`, data);
}

function save_multiple_vehicle(data) {
  return http.post(`GeofencMultiassign_tovehicle`, data);
}

function fencing_report(data) {
  return http.post(`assign_geofenc_report`, data);
}

function fetch_alert_list(data) {
  return http.post(`allAlertList`, data);
}

const GeofencingService = {
  getGeofencingList,
  addgeofencingdata,
  UpdateGeofencing,
  deleteGeofencingData,
  fencingAllotTovehicle,
  fetch_district_list,
  fetch_vehicle_list,
  save_multiple_vehicle,
  fencing_report,
  fetch_alert_list,
};

export default GeofencingService;
// ====================================
